import { Component, Input } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  @Input() title?: string;
  @Input() message?: string;

  constructor(
    private _modalController: ModalController,
    public platform: Platform,
    public translateService: TranslateService
  ) {}

  confirm(response: boolean) {
    this._modalController.dismiss(response ? 'confirm' : 'cancel');
  }
}
